export const DROP_LINE_THICKNESS = 4;

export const NEW_WIDGET_SYMBOL = Symbol("NEW_WIDGET_ID");

export const STACK_ADJUSTMENT_EPSILON = 0.01;
